/* eslint-disable no-unneeded-ternary */
/* eslint-disable dot-notation */
import { Button, Checkbox, FormControl, FormGroup, FormHelperText } from "@mui/material";
import MFormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import enLocale from "date-fns/locale/en-US";
import React, { Fragment } from "react";
import PhoneInput from "react-phone-input-2";
import NumberFormatter from "../../components/NumberFormatter";

import { DEFAULT_DATE_FORMAT, MSGS } from "../../constants";
import { IRenderField } from "../../constants/common-interface";
import { IOption, ITemplateConfig } from "../../constants/model-interfaces";
import FormUtils from "../../utils/FormUtil";
import BaseFormControl from "./base-form-control";
import { MandatoryLabel, Search as MuiSearch } from "./common";
import ModalSearchControl from "./Modalsearch";
import Multitext from "./Multitext";
import CustomDatePickerToolbar from "../../components/DatePicker/CustomToolbar";

// import MuiPhoneNumber from "mui-phone-number";

export default class MUIFormControl extends BaseFormControl {
    variant: string;
    size: any;
    constructor(props: IRenderField) {
        super(props);
        this.variant = "standard";
        this.handleValidation = this.handleValidation.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    render(): JSX.Element {
        const muiVariant = this.context.getThemeProp("mui", "variant");
        const muiSize = this.context.getThemeProp("mui", "size");
        this.variant = muiVariant || "standard";
        this.size = muiSize;
        return super.render();
    }

    getVariant() {
        return this.field.meta?.mui?.variant ? this.field.meta.mui.variant : this.variant;
    }

    hint(): JSX.Element {
        const meta = this.props.form;
        const iconName = meta.icons ? Object.keys(meta.icons)[0] : "";
        const icon = this.context.getIcon(iconName);
        return (
            <div className={`${this.getWrapperClassName()} hint-wrapper`} onClick={this.handleChange}>
                <span>{icon}</span>
                <p className='hint-text'>{meta.displayName}</p>
            </div>
        );
    }

    label() {
        const meta = this.props.form;
        const fieldClassName = meta?.displayProps?.fieldLayout === "row" ? "d-md-flex flex-md-row justify-content-md-between" : "";
        const wrapperClassName = this.getWrapperClassName() + " " + fieldClassName;
        let hasStartIcon = false;
        let hasEndIcon = false;
        let startIcon = <Fragment />;
        let endIcon = <Fragment />;
        if (this.props.form.icons) {
            const allIcons = Object.keys(this.props.form.icons);
            allIcons &&
                allIcons.forEach((icon) => {
                    const actualIcon = this.props.form.icons && this.props.form.icons[icon] ? this.props.form.icons[icon] : undefined;
                    if (actualIcon?.type === "start") {
                        hasStartIcon = true;
                        const startIconValue = this.context.getIcon(actualIcon.type);
                        if (startIconValue !== "") {
                            startIcon = startIconValue;
                        }
                    }
                    if ((hasEndIcon = actualIcon?.type === "end")) {
                        hasEndIcon = true;
                        const endIconValue = this.context.getIcon(icon);
                        if (endIconValue) {
                            endIcon = endIconValue;
                        }
                    }
                });
        }
        return (
            <MFormControl size={this.size} fullWidth className={wrapperClassName}>
                <FormLabel className='field-label'>{meta.displayName}</FormLabel>
                <span className='field-value'>
                    {hasStartIcon && startIcon}
                    {meta.value}
                    {hasEndIcon && endIcon}
                </span>
            </MFormControl>
        );
    }

    date(props?: any) {
        const label = this.getDisplayLabel();
        const dateString = this.props.form?.value ? this.props.form.value + "" : "";
        const value = this.props.form?.value ? new Date(dateString) : null;
        const variant = this.getVariant();
        const min = this.props.form.validation?.min ? new Date(this.props.form.validation.min) : undefined;
        const max = this.props.form.validation?.max ? new Date(this.props.form.validation.max) : undefined;
        const openTo = this.props.form?.config?.openTo || undefined;
        const inputFormat = this.props.form?.config?.inputFormat || DEFAULT_DATE_FORMAT;
        const views = this.props.form?.config?.views || undefined;
        const isVersion2Toolbar = this.props.form?.config?.toolbarVersion === 2;
        const subProps = props || {};
        let localValue;
        const wrapperClassName = this.getWrapperClassName();
        const placeholder = this.props.form.placeholder || inputFormat;
        const infoText = this.props.form?.validation?.info_detail?.infoMsg || this.props.form?.validation?.infoDetail?.infoMsg;
        return (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale}>
                <DatePicker
                    {...subProps}
                    closeOnSelect
                    disabled={this.props.form.isDisabled}
                    readOnly={this.props.form.isReadonly}
                    label={label}
                    value={localValue || value}
                    views={views}
                    openTo={openTo}
                    inputFormat={inputFormat}
                    minDate={min}
                    maxDate={max}
                    DialogProps={{
                        className: "meta-form-date-picker"
                    }}
                    PopperProps={{
                        className: "meta-form-date-picker"
                    }}
                    onChange={(val: Date | null, inputString: string) => {
                        if (val === null && inputString === undefined) {
                            // input field is cleared
                            this.handleChange(null, "");
                        } else if (inputString === undefined) {
                            // popup is used
                            if (val) {
                                this.handleChange(null, FormUtils.getDateString(val));
                            } else {
                                this.handleChange(null, "");
                            }
                        } else {
                            // input field is used
                            // check input format
                            if (val && inputString && inputString.length === inputFormat.length) {
                                const formattedInpputSting = FormUtils.getLocalDateStringFormat(inputString, inputFormat);
                                const inputDate = Date.parse(formattedInpputSting);
                                if (isNaN(inputDate)) {
                                    this.setError(true, MSGS.ERROR_MSG.DATE_INVALID);
                                } else {
                                    this.handleChange(null, FormUtils.getDateString(new Date(inputDate)));
                                }
                            } else {
                                localValue = val;
                            }
                        }
                    }}
                    onClose={() => {
                        this.handleValidation();
                        this.context.emit("$field_close", {
                            section: this.section,
                            field: this.field.name,
                            value
                        });
                    }}
                    renderInput={(params) => (
                        <FormControl fullWidth>
                            <TextField
                                {...params}
                                variant={variant}
                                className={wrapperClassName}
                                inputProps={{
                                    ...params.inputProps,
                                    placeholder: placeholder,
                                    className: "native-input-" + this.field.name
                                }}
                                onBlur={this.handleValidation}
                                size={this.size}
                                error={this.state.error?.hasError ? true : undefined}
                                fullWidth
                            />
                            {this.showValidation(infoText)}
                        </FormControl>
                    )}
                    ToolbarComponent={isVersion2Toolbar ? CustomDatePickerToolbar : undefined}
                    components={
                        isVersion2Toolbar
                            ? {
                                  SwitchViewButton: () => null,
                                  SwitchViewIcon: () => null
                              }
                            : {}
                    }
                />
            </LocalizationProvider>
        );
    }

    month() {
        const dateString = this.props.form?.value ? this.props.form.value + "" : "";
        const value = this.props.form?.value ? new Date(dateString) : null;
        const label = this.getDisplayLabel();
        const variant = this.getVariant();
        const max = this.props.form.validation?.max ? new Date(this.props.form.validation.max) : undefined;
        const min = this.props.form.validation?.min ? new Date(this.props.form.validation.min) : undefined;
        const wrapperClassName = this.getWrapperClassName();
        const inputFormat = "MMM yyyy";
        const placeholder = this.props.form.placeholder || inputFormat;
        let localValue;
        return (
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enLocale}>
                <DatePicker
                    closeOnSelect
                    label={label}
                    openTo='year'
                    views={["year", "month"]}
                    value={localValue || value}
                    inputFormat={inputFormat}
                    minDate={min}
                    maxDate={max}
                    DialogProps={{
                        className: "meta-form-date-picker"
                    }}
                    PopperProps={{
                        className: "meta-form-date-picker"
                    }}
                    onChange={(val, inputString) => {
                        if (inputString) {
                            if (inputString.length >= 8) {
                                const dateValue = Date.parse(inputString);
                                if (!isNaN(dateValue)) {
                                    const dateString = FormUtils.getDateString(new Date(dateValue));
                                    this.handleChange(null, dateString);
                                } else {
                                    localValue = inputString;
                                }
                            } else {
                                localValue = inputString;
                            }
                        } else {
                            if (val) {
                                const isNan = isNaN(val.getTime());
                                if (isNan) {
                                    localValue = val;
                                } else {
                                    localValue = undefined;
                                    const dateString = FormUtils.getDateString(val);
                                    this.handleChange(null, dateString);
                                }
                            } else {
                                this.handleChange(null, "");
                            }
                        }
                    }}
                    onClose={() => {
                        this.handleValidation();
                        this.context.emit("$field_close", {
                            section: this.section,
                            field: this.field.name,
                            value
                        });
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            className={wrapperClassName}
                            variant={variant}
                            helperText={this.state.error.errorMsg || undefined}
                            placeholder={this.props.form.placeholder}
                            inputProps={{
                                ...params.inputProps,
                                placeholder: placeholder
                            }}
                            onBlur={this.handleValidation}
                            size={this.size}
                            error={this.state.error?.hasError ? true : undefined}
                            fullWidth
                        />
                    )}
                />
            </LocalizationProvider>
        );
    }

    input(type: string, props?: any, InputProps?: any) {
        const label = this.getDisplayLabel();
        const variant = this.getVariant();
        let infoText = this.props.form?.validation?.infoDetail?.infoMsg || this.props.form?.validation?.infoDetail?.infoMsg;
        const wrapperClassName = this.getWrapperClassName();
        const extraProps = props || {};
        const isInfoFnExists = infoText?.includes("$");
        if (isInfoFnExists) {
            const infoMsgFnName = this.props.form?.validation?.infoDetail?.infoMsgFn ?? "";
            const infoMsgFn = this.context.getFn(infoMsgFnName);
            infoText = infoMsgFn ? infoMsgFn(this.props.form) : null;
        }

        // const max
        return (
            <TextField
                className={wrapperClassName}
                name={this.props.name}
                type={type}
                label={label}
                variant={variant}
                fullWidth
                disabled={this.props.form.isDisabled}
                inputProps={{
                    className: "native-input-" + this.field.name,
                    readOnly: this.props.form.isReadonly,
                    ...extraProps
                }}
                InputProps={InputProps}
                placeholder={this.props.form?.placeholder}
                value={this.props.form?.value}
                error={this.state.error?.hasError ? true : undefined}
                helperText={this.state.error.errorMsg || infoText || undefined}
                onChange={this.handleChange}
                onBlur={this.handleValidation}
                size={this.size}
            />
        );
    }

    text() {
        const maxLength = this.props.form.validation?.max || "";
        const autoComplete = this.props.form?.config?.autocomplete || undefined;
        let extraProps;
        if (maxLength || autoComplete) {
            extraProps = {
                maxLength: maxLength,
                autoComplete
            };
        }
        return this.input("text", extraProps);
    }

    password() {
        return this.input("password");
    }

    email() {
        return this.input("email");
    }

    number() {
        return this.input("number");
    }

    radio() {
        const meta = this.props.form;
        const isRow = this.props.form?.displayProps?.optionsLayout === "row" ? true : undefined;
        const wrapperClassName =
            this.getWrapperClassName() + (this.props.form?.displayProps?.fieldLayout === "row" ? "d-md-flex flex-md-row justify-content-md-between" : "");
        const fieldLabelClassname = wrapperClassName ? "field-label d-md-flex align-items-md-center" : "field-label";
        const labelPlacement: any = this.props.form?.labelPlacement;
        return (
            <MFormControl size={this.size} fullWidth className={wrapperClassName}>
                <FormLabel className={fieldLabelClassname}>
                    {meta.displayName}
                    {this.validation.required && <MandatoryLabel />}
                </FormLabel>
                <RadioGroup
                    row={isRow}
                    value={this.props.form?.value}
                    onChange={(e) => {
                        const parentLabel = e.target.closest("label");
                        const datatype = parentLabel ? parentLabel.getAttribute("datatype") : "";
                        if (datatype) {
                            switch (datatype) {
                                case "boolean":
                                    {
                                        const val = e.target.value === "true";
                                        this.handleChange(e, val);
                                    }
                                    break;
                                default:
                                    this.handleChange(e);
                            }
                        } else {
                            this.handleChange(e);
                        }
                    }}
                >
                    {meta.options &&
                        meta.options.map((option) => {
                            const datatype = typeof option.value;
                            return (
                                <FormControlLabel
                                    datatype={datatype}
                                    labelPlacement={labelPlacement}
                                    key={option.value}
                                    value={option.value}
                                    control={<Radio />}
                                    label={option.label}
                                />
                            );
                        })}
                </RadioGroup>
            </MFormControl>
        );
    }

    radioButton(): JSX.Element {
        const meta = this.props.form;
        const isRow = this.props.form?.displayProps?.optionsLayout === "row" ? true : undefined;
        const wrapperClassName =
            this.getWrapperClassName() + (this.props.form?.displayProps?.fieldLayout === "row" ? "d-md-flex flex-md-row justify-content-md-between" : "");
        const fieldLabelClassname = wrapperClassName ? "field-label d-md-flex align-items-md-center" : "field-label";
        const icons = meta.icons;
        const startIconName = icons ? FormUtils.getIconNameByPosition("start", icons) : "";
        const endIconName = icons ? FormUtils.getIconNameByPosition("end", icons) : "";

        return (
            <MFormControl size={this.size} fullWidth className={wrapperClassName}>
                <FormLabel className={fieldLabelClassname}>
                    {meta.displayName + " "}
                    {this.validation.required && <MandatoryLabel />}
                </FormLabel>
                <div
                    className='row'
                    onClick={(e) => {
                        let button = e.target as any;
                        if (button && button.tagName !== "button") {
                            button = button.closest("button");
                        }
                        const datatype =
                            // eslint-disable-next-line dot-notation
                            button && button["getAttribute"] ? button["getAttribute"]("datatype") : "";
                        if (datatype) {
                            switch (datatype) {
                                case "boolean":
                                    {
                                        const val = e.target["value"] === "true" ? true : false;
                                        this.handleChange(e, val);
                                    }
                                    break;
                                default: {
                                    const val2 = button.value;
                                    this.handleChange(e, val2);
                                }
                            }
                        } else {
                            this.handleChange(e);
                        }
                        this.handleValidation();
                    }}
                >
                    {meta.options &&
                        meta.options.map((option) => {
                            const datatype = typeof option.value;
                            const className = option.value === meta.value ? "selected" : "";
                            return (
                                <div className='col' key={option.value}>
                                    <Button
                                        className={className}
                                        datatype={datatype}
                                        disabled={meta.isDisabled}
                                        value={option.value}
                                        variant='outlined'
                                        size='medium'
                                        sx={{
                                            padding: "1rem"
                                        }}
                                        fullWidth
                                    >
                                        {startIconName && startIconName === option.value ? this.context.getIcon(startIconName) : ""}
                                        {option.label}
                                        {endIconName && endIconName === option.value ? this.context.getIcon(endIconName) : ""}
                                    </Button>
                                </div>
                            );
                        })}
                </div>
                {this.showValidation()}
            </MFormControl>
        );
    }

    checkbox(): JSX.Element {
        const meta = this.props.form;
        const wrapperClassName = this.getWrapperClassName();
        return (
            <FormGroup>
                {meta.options &&
                    meta.options.map((option: { label: string; value: any }) => {
                        return (
                            <FormControlLabel
                                className={wrapperClassName}
                                key={option.value}
                                value={option.value}
                                control={
                                    <Checkbox
                                        checked={option.value === this.props.form.value}
                                        inputProps={{
                                            className: "native-checkbox-" + this.field.name
                                        }}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            this.handleChange(e, checked ? option.value : "");
                                            this.handleValidation();
                                        }}
                                        disabled={this.props.form.isDisabled}
                                    />
                                }
                                label={option.label}
                            />
                        );
                    })}
                {this.showValidation()}
            </FormGroup>
        );
    }

    select() {
        const meta = this.props.form;
        const options = this.props.form.options || [];
        const variant = this.getVariant();
        const label = this.getDisplayLabel();
        const wrapperClassName = this.getWrapperClassName();
        const infoText = this.props.form?.validation?.info_detail?.infoMsg || this.props.form?.validation?.infoDetail?.infoMsg;
        return (
            <MFormControl size={this.size} fullWidth error={this.state.error.hasError ? true : undefined} variant={variant} className={wrapperClassName}>
                <InputLabel className='meta-select-label'>{label}</InputLabel>
                <Select
                    label={meta.displayName}
                    value={this.props.form?.value}
                    disabled={this.props.form.isDisabled}
                    onOpen={(e) => {
                        if (this.props.form.events?.open) {
                            this.handleOpen(e);
                        } else {
                            // check config
                            if (this.props.form.config && this.props.form.config.type === "url") {
                                if (this.props.form?.config?.loadOn && this.props.form.config?.loadOn.indexOf("open") >= 0) {
                                    this.handleOpen(e);
                                }
                            }
                        }
                    }}
                    inputProps={{
                        className: "native-select-" + this.field.name
                    }}
                    onChange={(e) => {
                        const val = e.target.value;
                        const ref = options.find((o) => o.value === val);
                        this.handleChange(e, undefined, ref);
                        this.handleValidation();
                    }}
                >
                    {options &&
                        options.map((option: { label: string; value: string }, idx: number) => {
                            const datatype = typeof option.value;
                            return (
                                <MenuItem key={idx} datatype={datatype} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            );
                        })}
                </Select>
                {this.showValidation(infoText)}
            </MFormControl>
        );
    }

    multiselect(): JSX.Element {
        const meta = this.props.form;
        const options = this.props.form.options || [];
        const variant = this.getVariant();
        const label = this.getDisplayLabel();
        const wrapperClassName = this.getWrapperClassName();
        return (
            <MFormControl size={this.size} fullWidth error={this.state.error.hasError ? true : undefined} variant={variant} className={wrapperClassName}>
                <InputLabel className='meta-select-label'>{label}</InputLabel>
                <Select
                    multiple
                    label={meta.displayName}
                    value={this.props.form?.value}
                    disabled={this.props.form.isDisabled}
                    onOpen={(e) => {
                        if (this.props.form.events?.open) {
                            this.handleOpen(e);
                        }
                    }}
                    onChange={(e) => {
                        const val = e.target.value;
                        const ref = options.find((o) => o.value === val);
                        this.handleChange(e, undefined, ref);
                    }}
                    onBlur={this.handleValidation}
                >
                    {options &&
                        options.map((option: { label: string; value: string }) => {
                            const datatype = typeof option.value;
                            return (
                                <MenuItem key={option.value} datatype={datatype} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            );
                        })}
                </Select>
                {this.showValidation()}
            </MFormControl>
        );
    }

    multitext(): JSX.Element {
        return (
            <Fragment>
                <Multitext
                    displayLabel={this.getDisplayLabel() || ""}
                    inputs={this.props.form.config?.inputs || []}
                    placeholder={this.props.form.placeholder}
                    seperator={this.props.form.config?.separator || ""}
                    size={this.size}
                    value={this.props.form.value}
                    variant={this.getVariant()}
                    wrapperClassName={this.getWrapperClassName()}
                    updateValue={(value: string) => {
                        this.handleChange("", value);
                        this.handleValidation();
                    }}
                />
                {this.showValidation()}
            </Fragment>
        );
    }

    button() {
        return <Button variant='contained'>Contained</Button>;
    }

    search() {
        const restConfig = this.context.getRestConfig();
        return (
            <MuiSearch
                name={this.field.name}
                form={this.props.form}
                label={this.getDisplayLabel() || ""}
                variant={this.getVariant()}
                config={restConfig}
                handleChange={this.handleChange}
                handleValidation={this.handleValidation}
                context={this.context}
                section={this.section}
                error={this.state.error}
                loading={this.state.loading}
            />
        );
    }

    modalsearch() {
        return (
            <ModalSearchControl
                config={this.props.form.config}
                context={this.context}
                error={this.state.error}
                field={this.field.name}
                label={this.getDisplayLabel() || ""}
                options={this.props.form.options || []}
                section={this.props.section}
                value={this.props.form.value}
                variant={this.getVariant()}
                wrapperClassName={this.getWrapperClassName()}
                handleChange={(val: IOption) => {
                    this.handleChange("", val.value, val);
                    this.handleValidation();
                }}
            />
        );
    }

    file() {
        const meta = this.props.form;
        const fileUploadedIcon = this.context.getIcon("fileUploaded");
        const fileDeleteIcon = this.context.getIcon("fileDelete");
        const uploadIcon = this.context.getIcon("uploadIcon");
        const fileWidthClass = meta.value ? "w-80" : "w-100";
        const handleFileChange = (e: any) => {
            let value = e.target.value;
            if (value) {
                const valParts = value.split("\\");
                if (valParts && valParts.length > 0) {
                    value = valParts[valParts.length - 1];
                }
                this.handleChange(e, value);
                this.context.setFieldProp(this.section, this.field.name, "files", e.target.files);
                this.handleValidation();
            }
        };
        return (
            <MFormControl className={this.getWrapperClassName()} size={this.size} fullWidth error={this.state.error.hasError ? true : undefined}>
                <Button
                    className='meta-file-upload-btn'
                    variant='outlined'
                    size='large'
                    onClick={(e) => {
                        let target: any;
                        target = e.target;
                        const fileInput = target.parentElement.querySelector("input[type=file]");
                        fileInput && fileInput.click();
                    }}
                    sx={{
                        padding: "1.4rem"
                    }}
                    fullWidth
                >
                    {meta.value ? (
                        <div className='d-flex'>
                            {uploadIcon}
                            <span className='meta-file-value'> {meta.value}</span>
                            {fileUploadedIcon}
                            <span
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // delete file
                                    this.context.setFieldProp(this.section, this.field.name, "files", null);
                                    this.handleChange(e, "");
                                    this.handleValidation();
                                    // let target: any;
                                    // target = e.target;
                                    // const inputElement = FormUtils.createFileInput(fileWidthClass, this.field.name, meta.config?.accept, this.getDisplayLabel(), handleFileChange);
                                }}
                            >
                                {fileDeleteIcon}
                            </span>
                        </div>
                    ) : (
                        <Fragment>
                            {uploadIcon}
                            {this.getDisplayLabel()}
                        </Fragment>
                    )}
                </Button>
                <input
                    accept={meta.config?.accept}
                    className={`position-absolute opacity-0 ${fileWidthClass} h-100`}
                    type='file'
                    name={this.field.name}
                    title={this.getDisplayLabel()}
                    onChange={handleFileChange}
                />
                {this.showValidation()}
            </MFormControl>
        );
    }

    phone() {
        const meta = this.props.meta;
        const value = meta.value as string;
        return (
            <Fragment>
                <PhoneInput
                    country='in'
                    value={value}
                    onChange={(phone: string) => {
                        this.handleChange(null, phone);
                        this.validate(phone);
                    }}
                    onBlur={this.handleValidation}
                    isValid={(value, country, countries, hiddenAreaCodes) => {
                        let isValid = false;
                        if (value) {
                            isValid = value.length === 12;
                        } else {
                            if (meta.validation?.required) {
                                isValid = false;
                            }
                        }
                        return isValid;
                    }}
                />
                {this.showValidation()}
            </Fragment>
        );
    }

    currency() {
        const InputComponent = NumberFormatter;
        const maxLength = this.props.form.validation?.max || "";
        const autoComplete = this.props.form?.config?.autocomplete || undefined;
        let htmlProps = {};
        if (maxLength || autoComplete) {
            htmlProps = {
                maxLength: maxLength,
                autoComplete
            };
        }
        const extraProps = {
            inputComponent: InputComponent
        };
        return this.input("number", htmlProps, extraProps);
    }

    customControl(): JSX.Element {
        if (this.displayType) {
            const customWrapperClass = this.getWrapperClassName();
            let control = this.context.getControl(this.displayType);
            if (control) {
                control = React.cloneElement(control, {
                    field: this.props.form,
                    name: this.props.name,
                    form: this.context.form,
                    error: this.state.error
                });
            }
            return (
                <div className={customWrapperClass}>
                    {control}
                    {this.showValidation()}
                </div>
            );
        }
        return this.text();
    }

    templateControl(): JSX.Element {
        if (this.displayType) {
            const customWrapperClass = this.getWrapperClassName();
            const template = this.props.form?.config?.template || "";
            const control = this.context.getControlElements(template);
            let customComponent: JSX.Element | null = null;
            if (control) {
                customComponent = React.cloneElement(
                    control({
                        field: this.props.form,
                        form: this.context.form
                    })
                );
            }
            if (customComponent) {
                return (
                    <div className={customWrapperClass}>
                        {customComponent}
                        {this.showValidation()}
                    </div>
                );
            } else {
                return <Fragment />;
            }
        }
        return this.text();
    }

    showValidation(infoMsg?: string) {
        let className = "";
        let icon;

        const infoText = this.props.form?.validation?.infoDetail?.infoMsgFn;
        const isInfoFnExists = infoText?.includes("$");

        if (isInfoFnExists) {
            const infoMsgFnName = this.props.form?.validation?.infoDetail?.infoMsgFn ?? "";
            const infoMsgFn = this.context.getFn(infoMsgFnName);
            infoMsg = infoMsgFn ? infoMsgFn(this.props.form) : null;
        }

        if (this.state.error.hasError) {
            className = "meta-validation-error text-danger";
            icon = this.context.getIcon("error");
        } else {
            if (infoMsg) {
                className = "meta-validation-info";
                icon = this.context.getIcon("info");
            }
        }
        if (!icon) {
            icon = "";
        }
        return (
            <FormHelperText className={className}>
                {icon}
                {this.state.error.errorMsg || infoMsg}
            </FormHelperText>
        );
    }
}
